import React from "react";
import * as Icons from "lucide-react";
import { Sparkles } from "lucide-react";

const COLOR_MAP = {
  violet: { ring: "ring-violet-200", icon: "text-violet-600", chip: "bg-violet-50 text-violet-700 border-violet-200", grad: "from-violet-500/10 to-violet-500/0" },
  emerald: { ring: "ring-emerald-200", icon: "text-emerald-600", chip: "bg-emerald-50 text-emerald-700 border-emerald-200", grad: "from-emerald-500/10 to-emerald-500/0" },
  rose: { ring: "ring-rose-200", icon: "text-rose-600", chip: "bg-rose-50 text-rose-700 border-rose-200", grad: "from-rose-500/10 to-rose-500/0" },
  amber: { ring: "ring-amber-200", icon: "text-amber-600", chip: "bg-amber-50 text-amber-700 border-amber-200", grad: "from-amber-500/10 to-amber-500/0" },
  indigo: { ring: "ring-indigo-200", icon: "text-indigo-600", chip: "bg-indigo-50 text-indigo-700 border-indigo-200", grad: "from-indigo-500/10 to-indigo-500/0" },
  sky: { ring: "ring-sky-200", icon: "text-sky-600", chip: "bg-sky-50 text-sky-700 border-sky-200", grad: "from-sky-500/10 to-sky-500/0" },
  teal: { ring: "ring-teal-200", icon: "text-teal-600", chip: "bg-teal-50 text-teal-700 border-teal-200", grad: "from-teal-500/10 to-teal-500/0" },
};

export const ReportTemplateCard = ({ template, onSelect }) => {
  const Icon = Icons[template.icon] || Sparkles;
  const c = COLOR_MAP[template.color] || COLOR_MAP.violet;
  const disabled = template.status !== "ready" || !template.accessible;
  const isComingSoon = template.status === "coming_soon";

  return (
    <button
      data-testid={`report-template-${template.template_id}`}
      onClick={() => !disabled && onSelect(template)}
      disabled={disabled}
      className={`group relative text-left rounded-2xl border bg-white p-5 transition-all hover:shadow-lg hover:-translate-y-0.5 disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:translate-y-0 disabled:hover:shadow-none ${
        disabled ? "border-slate-200" : `border-slate-200 hover:${c.ring} hover:ring-2`
      }`}
    >
      <div className={`absolute inset-0 rounded-2xl bg-gradient-to-br ${c.grad} opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none`} />
      <div className="relative">
        <div className="flex items-start justify-between">
          <div className={`inline-flex items-center justify-center w-11 h-11 rounded-xl bg-slate-50 ${c.icon}`}>
            <Icon className="w-5 h-5" />
          </div>
          {isComingSoon && (
            <span className="text-[10px] uppercase tracking-wider font-semibold px-2 py-0.5 rounded-full bg-slate-100 text-slate-500 border border-slate-200">
              Coming soon
            </span>
          )}
          {!template.accessible && !isComingSoon && (
            <span className="text-[10px] uppercase tracking-wider font-semibold px-2 py-0.5 rounded-full bg-rose-50 text-rose-600 border border-rose-200">
              Locked
            </span>
          )}
        </div>
        <h3 className="mt-4 text-base font-semibold text-slate-900 leading-snug">{template.name}</h3>
        <p className="mt-1.5 text-sm text-slate-500 leading-relaxed line-clamp-2">{template.description}</p>
        <div className="mt-4 flex items-center gap-2 flex-wrap">
          {template.supports?.project && (
            <span className={`text-[10px] uppercase tracking-wider font-medium px-2 py-0.5 rounded-full border ${c.chip}`}>Project</span>
          )}
          {template.supports?.date_range && (
            <span className={`text-[10px] uppercase tracking-wider font-medium px-2 py-0.5 rounded-full border ${c.chip}`}>Date Range</span>
          )}
          {template.supports?.source_basis && (
            <span className={`text-[10px] uppercase tracking-wider font-medium px-2 py-0.5 rounded-full border ${c.chip}`}>Source Basis</span>
          )}
        </div>
      </div>
    </button>
  );
};

export default ReportTemplateCard;
